import { Compass, Home, Plus, UserRound, VenetianMask } from "lucide-react";
import { Link } from "react-router-dom";
import { navItems } from "../lib/navigation";
import { useActiveRoute } from "../hooks/useActiveRoute";

const icons = {
  首页: Home,
  话题: Compass,
  发布: Plus,
  树洞: VenetianMask,
  我的: UserRound,
};

export interface BottomNavProps {
  readonly compact?: boolean;
}

export function BottomNav({ compact = false }: BottomNavProps) {
  const isActive = useActiveRoute();
  const activeIndex = navItems.findIndex((item) => isActive(item.path));

  // Calculate indicator translateX (5 tabs, each 20% width)
  const indicatorOffset = activeIndex >= 0
    ? `calc(${activeIndex * 20}% + 12px)`
    : "-100%";

  return (
    <nav aria-label="主导航" className={compact ? "bottom-nav bottom-nav-compact" : "bottom-nav"}>
      <div
        className="bottom-nav-indicator"
        style={{ transform: `translateX(${indicatorOffset})` }}
      />
      {navItems.map((item) => {
        const Icon = icons[item.label as keyof typeof icons];
        const active = isActive(item.path);
        const isPublish = item.path === "/publish";

        return (
          <Link
            aria-current={active ? "page" : undefined}
            className={[
              "bottom-nav-item",
              active ? "bottom-nav-active" : "",
              isPublish ? "bottom-nav-publish" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            key={item.path}
            to={item.path}
          >
            <span className="bottom-nav-icon">
              <Icon size={isPublish ? 22 : 24} />
            </span>
            <span>{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
